import {createFetchClientWithAuth} from '../util/request/middleware'
import {camelCase as camelCaseObject} from 'change-case-object'

const client = createFetchClientWithAuth('v1/balance')


/**
 * Fetch balances
 * @url http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Balance/Balance_GetBalances
 * @return {{available: null, savings: number, account: number, errors: (*|{})}}
 */
export async function fetchBalances(){
	const response = await client.get('balances')

	return {
		available: response.AvailableBalance,
		savings: response.SavingsBalance,
		account: response.AccountBalance,
		errors: response.Errors || {}
	}
}

/**
 * Fetches the savings streams
 * @url http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Balance/Balance_GetSavingsStreams
 * @returns {}
 */
export async function fetchSavingStreams(){
	return camelCaseObject(await client.get('savingsStreams'))
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/balances.js